import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import SupportDropdown from "./SupportDropdown"

export const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({}, dispatch),
})

export const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SupportDropdown)
